import { useMemo } from "react";
import { useDefault } from "react-use";

import type { DocumentMetadata, DocumentPageMetadata } from "@moment/api-collab/api-types";

import { useEasel } from "../easel";
import { useCurrentDocument } from "./useCurrentDocument";

export const useEaselCurrentPage = (
	documentMetadata?: DocumentMetadata
): DocumentPageMetadata | null => {
	const easel = useEasel();

	const activePageID = useMemo(() => easel.pageId, [easel]);
	const currentDocument = useCurrentDocument();
	// Prioritize live currentDocument data over potentially stale documentMetadata
	// Fall back to documentMetadata only when currentDocument is not available (SSR)
	const [document] = useDefault(currentDocument, documentMetadata);

	const page = document?.pagesMetadata.find((page) => page.id === activePageID);

	return page ?? null;
};
